export const PAGE_SIZE = 10;

export const STATUS_OPTIONS = [
  { value: "", label: "All statuses" },
  { value: "active", label: "Active" },
  { value: "upcoming", label: "Upcoming" },
  { value: "expired", label: "Expired" },
  { value: "paused", label: "Paused" },
];

export const ENABLED_OPTIONS = [
  { value: "", label: "All" },
  { value: "true", label: "Enabled" },
  { value: "false", label: "Disabled" },
];

export const TYPE_OPTIONS = [
  { value: "", label: "All types" },
  { value: "product_discount", label: "product_discount" },
  { value: "category_discount", label: "category_discount" },
  { value: "subcategory_discount", label: "subcategory_discount" },
  { value: "newsletter_signup", label: "newsletter_signup" },
  { value: "threshold_discount", label: "threshold_discount" },
  { value: "buy_x_get_y", label: "buy_x_get_y" },
  { value: "free_gift", label: "free_gift" },
  { value: "custom", label: "custom" },
];
